var Widget          = require("./Widget");

var SidePanel = Widget.extend({

    options: {
        position: 'left'
    },

    /**
     *
     * @param options
     */
    initialize: function(options) {
        var that = this;

        SidePanel.__super__.initialize.call(that, options);

        that.getContainer().addClass('side-panel');
        that.getContainer().addClass(that.options.position);
    },

    onAdd: function(view) {
        var that = this,
            offset,
            container;

        container = that.getContainer();

        if (that.options.position == 'left') {
            offset = that.getContainer().outerWidth(true);
            view.getContainer().find('.omjs-map-container').css({
                left: offset
            });
        }
        if (that.options.position == 'right') {
            offset = that.getContainer().outerWidth(true);
            view.getContainer().find('.omjs-map-container').css({
                right: offset
            });
        }
        if (that.options.position == 'top') {
            offset = that.getContainer().outerHeight(true);
            view.getContainer().find('.omjs-map-container').css({
                top: offset
            });
        }
        if (that.options.position == 'bottom') {
            offset = that.getContainer().outerHeight(true);
            view.getContainer().find('.omjs-map-container').css({
                bottom: offset
            });
        }

        view.getMap().updateSize();
    }
});

module.exports = SidePanel;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/SidePanel.js
// module id = 248
// module chunks = 0